import { displayAmountWithUnit, timeStampToDateTimeLocal } from "../global/utils";

export class Spending {
    constructor(
        data={
            id: -1,
            amount: '',
            description: '',
            dateCreated: [],
            dateCreatedFormatted: '',
            dateCreatedFormattedWithYear: '',
            categoryId: -1,
            animate: false,
        },
        unit='$',
        unitSuffix=false,
        category=false,
        tallyId=-1,

    ) {
        this.id = data.id;
        this.amount = parseFloat(data.amount);
        this.description = data.description;
        this.dateCreated = data.dateCreated;
        this.dateCreatedFormatted = data.dateCreatedFormatted;
        this.dateCreatedFormattedWithYear = data.dateCreatedFormattedWithYear;
        this.categoryId = data.categoryId;
        this.category = category;
        this.unit = unit;
        this.unitSuffix = unitSuffix;
        this.animate = data.animate ? data.animate : false;
        this.tallyId = tallyId;
    }

    getId() {
        return this.id;
    }

    getAmount() {
        return this.amount;
    }

    getDescription() {
        return this.description;
    }

    getDateCreated() {
        return this.dateCreated;
    }

    getDateCreatedFormatted() {
        return this.dateCreatedFormatted;
    }

    getDateCreatedFormattedWithYear() {
        return this.dateCreatedFormattedWithYear;
    }

    getCategoryId() {
        return this.category.getId();
    }

    getCategory() {
        return this.category;
    }

    getCategoryIconName() {
        return this.category ? this.category.getIconName() : this.category;
    }

    displayAmount() {
        return displayAmountWithUnit(this.amount, this.unit, this.unitSuffix);
    }

    hasDescription() {
        return this.description;
    }

    toFormObject() {
        return {
            id: this.id,
            amount: this.amount,
            description: this.description,
            dateCreated: timeStampToDateTimeLocal(this.dateCreated),
            category_id: this.categoryId,
            tally_id: this.tallyId
        }
    }
}
